const demoLinkData = [
  {
    demoLink: "/",
    landingLink: "/landing-one",
    demoThumb: "/assets/images/demo-1.png",
    demoTitle: "Digital Marketing",
  },
  {
    demoLink: "/home-two",
    landingLink: "/landing-two",
    demoThumb: "/assets/images/demo-2.png",
    demoTitle: "Seo Agency",
  },
  {
    demoLink: "/home-three",
    landingLink: "/landing-three",
    demoThumb: "/assets/images/demo-3.png",
    demoTitle: "Creative Agency",
  },
  {
    demoLink: "/home-four",
    landingLink: "/landing-four",
    demoThumb: "/assets/images/demo-4.png",
    demoTitle: "AI Software",
  },
  {
    demoLink: "/home-five",
    landingLink: "/landing-five",
    demoThumb: "/assets/images/demo-5.png",
    demoTitle: "Business Consulting",
  },
  {
    demoLink: "/home-six",
    landingLink: "/landing-six",
    demoThumb: "/assets/images/demo-6.png",
    demoTitle: "ELearning",
  },
  {
    demoLink: "/home-seven",
    landingLink: "/landing-seven",
    demoThumb: "/assets/images/demo-7.png",
    demoTitle: "IT Business",
  },
  {
    demoLink: "/home-eight",
    landingLink: "/landing-eight",
    demoThumb: "/assets/images/demo-8.png",
    demoTitle: "Sass",
  },
  {
    demoLink: "/home-nine",
    landingLink: "/landing-nine",
    demoThumb: "/assets/images/demo-9.png",
    demoTitle: "App Landing",
  },
  {
    demoLink: "/",
    landingLink: "/landing-ten",
    demoThumb: "/assets/images/demo-10.png",
    demoTitle: "Personal Portfolio",
  },
];

const pagesLinkData = [
 
  {
    linkLabel: "Gestion commerciale",
    pageLink: "/Sage-100-Gestion-Commerciale",
  },
  {
    linkLabel: "Comptabilité",
    pageLink: "/Sage-100-Gestion-comptabilite",
  },
  {
    linkLabel: "Immobilisation",
    pageLink: "/Immobilisation",
  },
  {
    linkLabel: "Paie & RH",
    pageLink: "/Sage-100-Gestion-Paie-RH",
  },
  
  {
    linkLabel: "Sage BI",
    pageLink: "/Sage-BI",
  },
  
 
];
const Horoquartzlink = [
  {
    linkLabel: "Présentation Horoquartz",
    pageLink: "/horoquartz",
  },
  {
    linkLabel: "eTemptation",
    pageLink: "/etemptation",
  },
  {
    linkLabel: "Self Service",
    pageLink: "/self-service",
  },
  {
    linkLabel: "Contrôle d'accès",
    pageLink: "/controle-acces",
  },
];
 const Idemialink = [
  {
    linkLabel: "Présentation Idemia",
    pageLink: "/projects",
  },
  {
    linkLabel: "Morpho Manager Suite",
    pageLink: "/project-details",
  },
  {
    linkLabel: "Pointeuses IDEMIA",
    pageLink: "/service-details",
  },

];

export { demoLinkData, pagesLinkData, Horoquartzlink, Idemialink };
